import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLink, M2A, TextBlock } from 'www-cms';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { SafePipe } from 'common';
import { WWWConfig, WWW_CONFIG } from '../../shared/models/config.model';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-text-block',
  imports: [CommonModule, ButtonLinkComponent, SafePipe, DirectusDirective],
  templateUrl: './text-block.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextBlockComponent extends BaseBuildingBlockComponent {
  private wwwConfig = inject<WWWConfig>(WWW_CONFIG);

  @Input({ required: true }) textBlockData!: TextBlock;

  customTailwindClasses = ['md:mx-36'];

  trackButtons(index: number, item: M2A<ButtonLink>) {
    return item.item.id;
  }

  get backgroundImageUrl() {
    return this.textBlockData.backgroundImage
      ? `${this.wwwConfig.baseAssetUrl}/${this.textBlockData.backgroundImage.id}`
      : '';
  }

  override getBgClass(): LastItemBgClass {
    switch (this.textBlockData.backgroundColor) {
      case 'white':
        return 'bg-white';
      case 'black':
        return 'bg-black';
      case 'gray':
        return 'bg-ss-www-background';
      default:
        return 'bg-ss-www-background';
    }
  }
}
